/* eslint-disable no-unused-vars */
import { Select } from '@ngxs/store'
import { Observable, Subscription } from 'rxjs'
import { tap } from 'rxjs/operators'
import { ContentState } from '../store/state/content.state'
import { MessageState } from '../store/state/message.state'
import { StudentAdmissionsState } from '../store/state/student-admissions.state'
import { StudentAuditDocumentsState } from '../store/state/student-audit-documents.state'
import { StudentAuditsState } from '../store/state/student-audits.state'
import { ApiStatus } from './api-status'

export enum ApiStatusStreamType {
  ADMISSION,
  AUDIT,
  AUDITDOCUMENT,
  CONTENT,
  MESSAGES,
}
export interface IonicComponentLifecycles {
  ionViewWillEnter?: () => void
  ionViewDidEnter?: () => void
  ionViewWillLeave?: () => void
  ionViewDidLeave?: () => void
}

export class ApiClass implements ApiStatus {
  isFetching: boolean
  isInitialised: boolean
  hasApiError: boolean
  hasConnectionError: boolean
  subscription: Subscription

  @Select(StudentAdmissionsState.apiStatus)
  admissionApiStatusStream: Observable<ApiStatus>

  @Select(StudentAuditsState.apiStatus)
  auditApiStatusStream: Observable<ApiStatus>

  @Select(ContentState.apiStatus)
  contentApiStatusStream: Observable<ApiStatus>

  @Select(StudentAuditDocumentsState.apiStatus)
  auditDocumentApiStatusStream: Observable<ApiStatus>

  @Select(MessageState.apiStatus)
  messageApiStatusStream: Observable<ApiStatus>

  constructor(variant: ApiStatusStreamType) {
    this.isFetching = false
    this.isInitialised = false
    this.hasApiError = false
    this.hasConnectionError = false
    this.listenToApiStatusChanges(variant)
  }

  private listenToApiStatusChanges(variant: ApiStatusStreamType) {
    let observable: Observable<ApiStatus>
    switch (variant) {
      case ApiStatusStreamType.ADMISSION: {
        observable = this.admissionApiStatusStream
        break
      }
      case ApiStatusStreamType.AUDIT: {
        observable = this.auditApiStatusStream
        break
      }
      case ApiStatusStreamType.CONTENT: {
        observable = this.auditApiStatusStream
        break
      }
      case ApiStatusStreamType.AUDITDOCUMENT: {
        observable = this.auditDocumentApiStatusStream
        break
      }
      case ApiStatusStreamType.MESSAGES: {
        observable = this.messageApiStatusStream
        break
      }
      default: {
        throw new Error('observable variant not supported')
      }
    }
    this.subscription = observable
      .pipe(
        tap(({ isFetching, isInitialised }) => {
          this.isFetching = isFetching
          this.isInitialised = !this.isInitialised
            ? isInitialised
            : this.isInitialised
        })
      )
      .subscribe()
  }
}
